import { StudentWithAttendance } from "@/types/attendance";
import { LateRecord } from "@/hooks/useLateAttendance";
import { calculateStudentLateCount } from "./reportCalculations";
import { dateSplitter } from "../formatting/deteSplitter";

export const transformStudentsWithLateData = (
  studentsWithAttendance: StudentWithAttendance[],
  lateRecords: LateRecord[],
  periodDateRange?: { startDate: Date; endDate: Date }
): StudentWithAttendance[] => {
  // console.log('=== Transform Students Debug ===');
  // console.log('Period date range:', periodDateRange);
  // console.log('Late records count:', lateRecords.length);
  // console.log('Students input count:', studentsWithAttendance.length);

  // إذا لم توجد سجلات تأخر، جميع الطلاب غير متأخرين
  if (lateRecords.length === 0) {
    // console.log('No late records found - all students are on time');
    return studentsWithAttendance.map((student) => ({
      ...student,
      lateDays: 0, // تأكد من أن جميع الطلاب غير متأخرين
    }));
  }

  return studentsWithAttendance.map((student) => {
    const studentLateCount = calculateStudentLateCount(
      student.id,
      lateRecords,
      periodDateRange
    );

    // console.log(`Student ${student.name} (${student.id}): original lateDays = ${student.lateDays}, calculated = ${studentLateCount}`);

    return {
      ...student,
      lateDays: studentLateCount,
    };
  });
};

export const generateWeeklyData = (attendanceRecords: any[]) => {
  const dataMap = new Map();
  const today = new Date();

  // Collect data for the last 7 days
  for (let i = 6; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    const dayOfWeek = date.getDay(); // 0 = Sunday, 5 = Friday, 6 = Saturday

    // Skip Friday (5) and Saturday (6)
    if (dayOfWeek === 5 || dayOfWeek === 6) {
      continue;
    }

    const dateString = dateSplitter(date);

    const dayRecords = attendanceRecords.filter(
      (record) => record.date === dateString
    );
    const presentCount = dayRecords.filter(
      (record) => record.status === "present"
    ).length;
    const absentCount = dayRecords.filter(
      (record) =>
        record.status === "absent" || record.status === "absent_with_reason"
    ).length;
        const absentCountWithReason= dayRecords.filter(
      (record) =>
        record.status === "absent_with_reason"
    ).length;
    const lateCount = dayRecords.filter(
      (record) => record.status === "late"
    ).length;

    const dayName = date.toLocaleDateString("ar", { weekday: "long" });

    dataMap.set(dayOfWeek, {
      day: dayName,
      present: presentCount,
      withReason: absentCountWithReason,
      absent: absentCount,
      late: lateCount,
      date: dateString,
      dayOfWeek,
    });
  }

  // Order the data: Sunday (0), Monday (1), Tuesday (2), Wednesday (3), Thursday (4)
  const orderedData = [];
  for (let day = 0; day <= 4; day++) {
    if (dataMap.has(day)) {
      orderedData.push(dataMap.get(day));
    }
  }

  return orderedData;
};
